module.exports = __webpack_public_path__ + "img/ABPIP-colorida.18d8d062.png";